import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'attention-services',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'attention-services-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                                        {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.attention-services-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "attention-services-index" */ '@/modules/configurations/catalogs/attention-services/views/Index.vue')
        }
    ]
}
